// extracted by mini-css-extract-plugin
export var addButton = "_cw-0";
export var border = "_cw-8";
export var check = "_cw-h";
export var danger = "_cw-6";
export var dropdownContainer = "_cw-1";
export var editModalBody = "_cw-j";
export var footerContainer = "_cw-i";
export var fullWidth = "_cw-a";
export var hide = "_cw-9";
export var icon = "_cw-3";
export var input = "_cw-7";
export var inputFlex = "_cw-b";
export var inputWrapper = "_cw-c";
export var manualFocus = "_cw-5";
export var optionButton = "_cw-4";
export var pillWrapper = "_cw-e";
export var pointer = "_cw-2";
export var showOverflow = "_cw-f";
export var tagsFlex = "_cw-d";
export var xButton = "_cw-g";